import { render, staticRenderFns } from "./ModalDeductionForm.vue?vue&type=template&id=3f2912f0&scoped=true"
import script from "./ModalDeductionForm.vue?vue&type=script&lang=js"
export * from "./ModalDeductionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2912f0",
  null
  
)

export default component.exports